/*
  Gymtastic - Aktionspreis-Umschaltung  (v8)
  ------------------------------------------
  Die Seite rendert serverseitig IMMER den Listenpreis. Nur wenn ein
  Aktionscode nachweislich vorliegt, schaltet dieses Script auf 49 EUR um.

  RANGFOLGE DER QUELLEN
    1. Warenkorb gefuellt -> /cart.js ist die Wahrheit.
       Ein Code zaehlt nur, wenn applicable === true.
    2. Warenkorb leer     -> Shopify-Cookie "discount_code".
    3. URL-Parameter ?code= (Fallback fuer Sonderfaelle).
    4. Innerhalb der Session gemerkt (sessionStorage).

  WARUM DAS COOKIE:
  Bei leerem Warenkorb meldet /cart.js grundsaetzlich applicable:false -
  es gibt ja nichts zu rabattieren. Der Code liegt aber trotzdem schon
  in der Session, sobald der Besucher ueber /discount/CODE kam.
  Shopify legt ihn dabei als lesbares Cookie "discount_code" ab.

  WARUM UEBERHAUPT EINE CODELISTE (wichtig, nicht wegoptimieren):
  Der Shop hat viele aktive Prozent-Codes auf ALLE Produkte (30-60%).
  Wuerde die Seite bei jedem beliebigen Cookie-Code auf 49 EUR schalten,
  saehe jemand mit einem 40%-Influencer-Code hier 49 EUR, muesste an der
  Kasse aber 89,40 EUR zahlen. Die Seite schaltet deshalb nur bei Codes
  um, die nachweislich 100 EUR auf das Sommer-Set geben.

  NEU in v8 - CODELISTE AUS ZWEI QUELLEN, TRAEGE GELESEN:
    a) window.GT_PROMO.codes         Section-Einstellung, von Hand gepflegt
    b) window.GT_PROMO_CODES_EXTRA   Shop-Metafeld custom.sommerset_promo_codes,
                                     wird automatisch synchronisiert
  Beide werden erst beim Pruefen ausgelesen, nicht beim Laden des Scripts.
  Dadurch ist die Reihenfolge der Script-Bloecke egal - (b) darf auch
  spaeter im Dokument gesetzt werden.

  Neue Aktionscodes muessen damit nirgends mehr von Hand eingetragen werden.
  Die Section-Einstellung bleibt als manuelle Notfall-Option bestehen.
*/
(function(){
  var CFG = window.GT_PROMO;
  if(!CFG) return;

  var SKEY = 'gtsl_promo_active';
  var promoActive = false;

  function money(cents){ return (cents/100).toFixed(2).replace('.', ',') + '€'; }
  function byId(id){ return document.getElementById(id); }

  /* Traege gelesen: Section-Liste + automatisch gepflegtes Metafeld. */
  function allCodes(){
    var a = String(CFG.codes || '');
    var b = String(window.GT_PROMO_CODES_EXTRA || '');
    return (a + ',' + b).split(',').map(function(s){
      return s.trim().toLowerCase();
    }).filter(Boolean);
  }
  function known(code){
    return allCodes().indexOf(String(code || '').trim().toLowerCase()) > -1;
  }

  /* Quelle 1: Code greift nachweislich im Warenkorb. */
  function greift(d){ return d && d.applicable === true && known(d.code); }

  /* Quelle 2: Shopify-Cookie - funktioniert auch bei leerem Warenkorb. */
  function fromCookie(){
    try{
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      if(!m) return null;
      var c = decodeURIComponent(m[1] || '');
      return known(c) ? c : null;
    }catch(e){ return null; }
  }

  /* Quelle 3: URL-Parameter (Sonderfall). */
  function fromUrl(){
    try{
      var q = new URLSearchParams(window.location.search);
      var c = q.get('code') || q.get('discount') || q.get('dc');
      return c && known(c) ? c : null;
    }catch(e){ return null; }
  }

  function remember(on){
    try{ on ? sessionStorage.setItem(SKEY,'1') : sessionStorage.removeItem(SKEY); }catch(e){}
  }
  function recalled(){
    try{ return sessionStorage.getItem(SKEY) === '1'; }catch(e){ return false; }
  }

  function checkedRadio(){
    return document.querySelector('input[name="gtslQty"]:checked');
  }

  function values(){
    var r = checkedRadio();
    if(!r) return { list: CFG.list, eff: CFG.eff };
    return {
      list: parseInt(r.getAttribute('data-list'), 10) || CFG.list,
      eff:  parseInt(r.getAttribute('data-eff'), 10)  || CFG.eff
    };
  }

  function paint(){
    var v = values();
    var now = promoActive ? v.eff : v.list;

    var priceEl = byId('gtslPrice');
    if(priceEl) priceEl.textContent = money(now);

    var wasEl = byId('gtslWas');
    if(wasEl){
      if(promoActive){ wasEl.textContent = money(v.list); wasEl.hidden = false; }
      else { wasEl.hidden = true; }
    }

    var pillEl = byId('gtslPill');
    if(pillEl) pillEl.hidden = !promoActive;

    var atcP = byId('gtslAtcP');
    if(atcP) atcP.textContent = money(now);

    var finP = byId('gtslFinP');
    if(finP) finP.textContent = money(now);

    var stP = byId('gtslStP');
    if(stP){
      stP.innerHTML = promoActive
        ? money(now) + ' <span class="gtsl-sticky__was">' + money(v.list) + '</span>'
        : money(now);
    }

    document.querySelectorAll('input[name="gtslQty"]').forEach(function(r){
      var card = r.parentNode.querySelector('.gtsl-bd__p');
      if(!card) return;
      var val = parseInt(r.getAttribute(promoActive ? 'data-eff' : 'data-list'), 10) || 0;
      card.textContent = money(val);
    });

    var hint = byId('gtslPromoHint');
    var live = byId('gtslPromoLive');
    if(hint) hint.hidden = promoActive;
    if(live) live.hidden = !promoActive;

    document.documentElement.classList.toggle('gt-promo-on', promoActive);
  }

  function offline(){ return !!(fromCookie() || fromUrl()) || recalled(); }

  function detect(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var codes = cart.discount_codes || [];

        if(codes.some(greift)){ promoActive = true; remember(true); return; }

        /* Warenkorb gefuellt, aber kein Code greift -> ehrlich bleiben. */
        if((cart.item_count || 0) > 0){ promoActive = false; remember(false); return; }

        /* Warenkorb leer: Cookie / URL / Session entscheiden. */
        promoActive = offline();
        remember(promoActive);
      })
      .catch(function(){ promoActive = offline(); });
  }

  document.addEventListener('change', function(e){
    if(e.target && e.target.name === 'gtslQty') paint();
  });

  document.addEventListener('cart:refresh', function(){
    detect().then(paint);
  });

  function init(){
    /* Sofort entscheiden, damit niemand kurz 149 EUR sieht. */
    if(offline()){ promoActive = true; remember(true); }
    paint();
    detect().then(paint);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  window.GTPromo = {
    refresh: function(){ return detect().then(paint); },
    isActive: function(){ return promoActive; },
    codes: allCodes
  };
})();
